import { render } from "./InputNome.vue?vue&type=template&id=be1377a6&scoped=true"
import script from "./InputNome.vue?vue&type=script&lang=js"
export * from "./InputNome.vue?vue&type=script&lang=js"

import "./InputNome.vue?vue&type=style&index=0&id=be1377a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1377a6"]])

export default __exports__